module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Regular-608dbe34b525dbf880b8d8ce921a5b54.woff";